import React, { useState, useEffect } from 'react';



const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



const AddPaymentPlan = () => {
    const [mobileNo, setMobileNo] = useState('');
    const [type, setType] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [transactionNo, setTransactionNo] = useState('');
    const [transactionDate, setTransactionDate] = useState('');
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState('');
    // const [errors, setErrors] = useState({});
    const [screenshot, setScreenshot] = useState(null); // Payment screenshot
    const [remarks, setRemarks] = useState(''); // Remarks

    useEffect(() => {
        if (type) {
            // Fetch plans based on the selected type
            fetch(`${API_BASE_URL}/api/plans?type=${type}&is_active=1`)
                .then(response => response.json())
                .then(data => setPlans(data))
                .catch(error => console.error('Error fetching plans:', error));
        } else {
            setPlans([]);
        }
    }, [type]);


    // const validate = () => {
    //     const newErrors = {};
    //     const today = new Date();
    //     const enteredDate = new Date(transactionDate);
    //     const minValidDate = new Date("2000-01-01");

    //     if (!mobileNo) {
    //         newErrors.mobileNo = "Mobile No is required.";
    //     } else if (!/^\d{10}$/.test(mobileNo)) {
    //         newErrors.mobileNo = "Mobile Number must be 10 digits.";
    //     }

    //     if (!type) newErrors.type = "Type is required.";

    //     if (!selectedPlan) newErrors.selectedPlan = "Please select a payment plan.";

    //     if (!transactionNo) {
    //         newErrors.transactionNo = "Transaction No is required.";
    //     }

    //     if (!transactionDate) {
    //         newErrors.transactionDate = "Transaction Date is required.";
    //     } else if (isNaN(enteredDate.getTime())) {
    //         newErrors.transactionDate = "Invalid date format.";
    //     } else if (enteredDate > today) {
    //         newErrors.transactionDate = "Transaction Date cannot be in the future.";
    //     } else if (enteredDate < minValidDate) {
    //         newErrors.transactionDate = "Transaction Date cannot be before 2000.";
    //     }

    //     if (!paymentMode) {
    //         newErrors.paymentMode = "Payment Mode is required.";
    //     }

    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };



// const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!mobileNo || !type) {
//         alert("Please enter mobile number and select type.");
//         return;
//     }

//     const selectedPlanData = plans.find(plan => plan.id.toString() === selectedPlan);

//     if (!selectedPlanData) {
//         alert("Please select a plan before proceeding.");
//         return;
//     }

//     // Fetch the logged-in user from localStorage
//     const loggedInUser = localStorage.getItem('username') || 'UnknownUser'; 

//     const requestData = {
//         mobileNo,
//         type,
//         planid: selectedPlanData.id,
//         transactionNo,
//         transactionDate,
//         actual_amount: selectedPlanData.original,
//         total_amount: selectedPlanData.totalPayable,
//         gst_percent: selectedPlanData.gst_percent,
//         gst_amount: selectedPlanData.gstAmount,
//         validity: selectedPlanData.validity_days,
//         paymentMode,  
//         loggedInUser  
//     };

//     try {
//         const response = await fetch(`${API_BASE_URL}/api/addPayment`, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(requestData)
//         });

//         const result = await response.json();

//         if (result.success) {
//             alert("Payment details saved successfully!");
//             window.location.reload(); // Reload the page after success
//         } else {
//             alert(result.error || "Error saving payment details.");
//         }
//     } catch (error) {
//         console.error("Error:", error);
//         alert("An error occurred while saving payment details.");
//     }
// };

const handleFileChange = (e) => {
    setScreenshot(e.target.files[0]); // Store file object
};

const handleSubmit = async (e) => {
    e.preventDefault();


        // Retrieve logged-in username from localStorage
        const loggedInUser = localStorage.getItem("username");
        
        // Prevent submission if user is not logged in
        if (!loggedInUser) {
            alert("Please log in before submitting payment details.");
            return;
        }

        
    if (!mobileNo || !type) {
        alert("Please enter mobile number and select type.");
        return;
    }

    const selectedPlanData = plans.find(plan => plan.id.toString() === selectedPlan);

    if (!selectedPlanData) {
        alert("Please select a plan before proceeding.");
        return;
    }

    // const loggedInUser = localStorage.getItem('username') || 'UnknownUser';

    let paymentScreenshotUrl = ''; // Placeholder for screenshot URL

    // Upload screenshot if file is selected
    if (screenshot) {
        const formData = new FormData();
        formData.append("file", screenshot);
        
        try {
            const uploadResponse = await fetch(`${API_BASE_URL}/api/upload-payment-screenshot`, {
                method: "POST",
                body: formData
            });

            const uploadResult = await uploadResponse.json();
            if (uploadResult.success) {
                paymentScreenshotUrl = uploadResult.fileUrl;
            } else {
                alert("Error uploading screenshot.");
                return;
            }
        } catch (error) {
            console.error("Error uploading screenshot:", error);
            alert("An error occurred while uploading screenshot.");
            return;
        }
    }

    const requestData = {
        mobileNo,
        type,
        planid: selectedPlanData.id,
        transactionNo,
        transactionDate,
        actual_amount: selectedPlanData.original,
        total_amount: selectedPlanData.totalPayable,
        gst_percent: selectedPlanData.gst_percent,
        gst_amount: selectedPlanData.gstAmount,
        validity: selectedPlanData.validity_days,
        paymentMode,  
        loggedInUser,
        payment_screenshot: paymentScreenshotUrl,
        remark: remarks // Include remarks field
    };

    try {
        const response = await fetch(`${API_BASE_URL}/api/addPayment`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData)
        });

        const result = await response.json();

        if (result.success) {
            alert("Payment details saved successfully!");
            window.location.reload();
        } else {
            alert(result.error || "Error saving payment details.");
        }
    } catch (error) {
        console.error("Error:", error);
        alert("An error occurred while saving payment details.");
    }
};

    
        
    const calculateGST = (amount, gstPercent) => {
        return (amount * gstPercent) / 100;
    };

    const calculateTotalPayable = (amount, gstAmount) => {
        return amount + gstAmount;
    };

    return (
        <div className="bg-gray-100 p-1">
            <div className="max-w-2xl mx-auto p-6 mb-2">
                <div className="max-w-4xl mx-auto mt-12 bg-white shadow-lg rounded-lg p-8">
                    <h1 className="text-2xl font-semibold mb-6 text-blue-700">Add Payment Plan</h1>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label htmlFor="mobileNo" className="block text-sm font-medium text-gray-700">Mobile No<span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                id="mobileNo"
                                value={mobileNo}
                                onChange={(e) => setMobileNo(e.target.value)}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                            {/* {errors.mobileNo && <p className="text-red-500 text-sm">{errors.mobileNo}</p>} */}

                        </div>

                        <div>
                            <label htmlFor="type" className="block text-sm font-medium text-gray-700">Type</label>
                            <select
                                id="type"
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            >
                                <option value="">Select Type</option>
                                <option value="ஜோதிடர்">ஜோதிடர்</option>
                                <option value="ஐயர்">ஐயர்</option>
                                <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                                <option value="எண்கணிதம்">எண்கணிதம்</option>
                                <option value="சிற்பி">சிற்பி</option>
                                <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
                                <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
                                <option value="திருவிழா அலங்காரம் செய்பவர்">திருவிழா அலங்காரம் செய்பவர்</option>
                                <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
                                <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
                            </select>
                            {/* {errors.type && <p className="text-red-500 text-sm">{errors.type}</p>} */}

                        </div>

                        <div>
                            <label htmlFor="paymentMode" className="block text-sm font-medium text-gray-700">Payment Mode<span className="text-red-500">*</span></label>
                            <select
                                id="paymentMode"
                                value={paymentMode}
                                onChange={(e) => setPaymentMode(e.target.value)}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            >
                                <option value="">Selected Payment Mode</option>
                                <option value="Google Pay">Google Pay</option>
                                <option value="PhonePe">Phone PE</option>
                                <option value="AXIS Bank">AXIS Bank</option>
                                <option value="UPI Payment">UPI Payment</option>
                                <option value="Store Payment">Store Payment</option>
                                <option value="Account Pay">Account Pay</option>
                                <option value="App Payment">App Payment</option>
                                <option value="Cash">Cash</option>
                                <option value="PAY TM">PAY TM</option>
                                <option value="Others">Others</option>
                                <option value="Free Mode">Free Mode</option>
                            </select>
                            {/* {errors.paymentMode && <p className="text-red-500 text-sm">{errors.paymentMode}</p>} */}

                        </div>

                        <div>
                            <label htmlFor="transactionNo" className="block text-sm font-medium text-gray-700">Transaction No<span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                id="transactionNo"
                                value={transactionNo}
                                onChange={(e) => setTransactionNo(e.target.value)}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                                                        {/* {errors.transactionNo && <p className="text-red-500 text-sm">{errors.transactionNo}</p>} */}

                        </div>
{/* 
                        <div>
                            <label htmlFor="transactionDate" className="block text-sm font-medium text-gray-700">Transaction Date<span className="text-red-500">*</span></label>
                            <input
                                type="date"
                                id="transactionDate"
                                value={transactionDate}
                                onChange={(e) => setTransactionDate(e.target.value)}
                                required
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                        </div> */}


<div>
    <label htmlFor="transactionDate" className="block text-sm font-medium text-gray-700">
        Transaction Date<span className="text-red-500">*</span>
    </label>
    <input
        type="date"
        id="transactionDate"
        value={transactionDate}
        onChange={(e) => setTransactionDate(e.target.value)}
        required
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 cursor-pointer"
        onKeyDown={(e) => e.preventDefault()} // Prevents manual entry
        onClick={(e) => e.target.showPicker()} // Opens date picker when clicked
    />
</div>


                        <div>
                            <label className="block text-sm font-medium text-blue-700">Select Plan</label>
                            {plans.length > 0 ? (
                                plans.map((plan) => {
                                    const gstAmount = calculateGST(plan.original, plan.gst_percent);
                                    const totalPayable = calculateTotalPayable(plan.original, gstAmount);
                                    return (
                                        <div key={plan.id} className="mt-2">
                                            <label className="inline-flex items-center">
                                            <input
    type="radio"
    name="plan"
    value={plan.id.toString()} // Ensure it's a string
    checked={selectedPlan === plan.id.toString()} // Convert plan.id to a string for comparison
    onChange={(e) => setSelectedPlan(e.target.value)}
    className="form-radio text-green-600"
/>

                                                <span className="ml-3 text-red-600">
                                                    {`${plan.name} | Plan Amount: ₹${plan.original} | GST Amount (${plan.gst_percent}%): ₹${gstAmount.toFixed(2)} | Total Payable Amt: ₹${totalPayable.toFixed(2)} | Validity: ${plan.validity_days} days`}
                                                </span>
                                            </label>
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="text-red-500">No plans available for the selected type.</p>
                            )}
                                                        {/* {errors.selectedPlan && <p className="text-red-500 text-sm">{errors.selectedPlan}</p>} */}

                        </div>
    {/* Upload Payment Screenshot */}
    <div>
                            <label htmlFor="screenshot" className="block text-sm font-medium text-gray-700">Upload Payment Screenshot</label>
                            <input type="file" id="screenshot" accept="image/*" onChange={handleFileChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"/>
                        </div>

                        {/* Remarks */}
                        <div>
                            <label htmlFor="remarks" className="block text-sm font-medium text-gray-700">Remarks</label>
                            <textarea id="remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" rows="3"></textarea>
                        </div>

                        <button type="submit" className="w-full bg-green-500 text-white font-bold py-2 rounded hover:bg-green-600">
                            Save Payment Details
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddPaymentPlan;